<template>
    <div>
    Dashboard view 1
    </div>
</template>

<script>
export default {
name:'dashboard1'
}
</script>

<style>

</style>
